import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

import { getSurveyQuestionTypes } from "../data/questionTypes";
import type { SurveyQuestion } from "../types/survey.types";
import SurveyQuestionPreviewCard from "./form/SurveyQuestionPreviewCard";

interface SurveyDetailQuestionsProps {
  questions?: SurveyQuestion[];
}

export default function SurveyDetailQuestions({ questions = [] }: SurveyDetailQuestionsProps) {
  const { t } = useTranslation();
  const questionTypeMap = new Map(
    getSurveyQuestionTypes(t).map((item) => [item.value, item.label] as const),
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <FileText className="h-5 w-5 text-gray-600 dark:text-gray-300" />
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Questions ({questions.length})
        </h2>
      </div>

      {questions.length > 0 ? (
        <div className="space-y-4">
          {questions.map((question, index) => (
            <SurveyQuestionPreviewCard
              key={question.position}
              question={question}
              index={index}
              questionTypeLabel={questionTypeMap.get(question.type)}
              requiredLabel={t("ui.required")}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500 dark:text-gray-300">
          No questions found for this survey.
        </div>
      )}
    </div>
  );
}
